// pages/MotsSignales.jsx
// Page de gestion des mots signalés comme erronés

import React, { useState, useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import GestionMots from '../components/GestionMots';
import './MotsSignales.css';

export default function MotsSignales() {
  const [mots, setMots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [contextes, setContextes] = useState([]);

  // Charger les mots signalés et les contextes au montage
  useEffect(() => {
    loadMotsSignales();
    loadContextes();
  }, []);

  // Charger la liste des contextes prédéfinis
  const loadContextes = async () => {
    try {
      const response = await fetch('/api/contextes');
      const data = await response.json();

      if (data.success) {
        // Trier les contextes par ordre alphabétique (par label)
        const contextesTries = [...(data.contextes || [])].sort((a, b) => {
          // Garder "(Aucun contexte)" en premier
          if (a.value === '') return -1;
          if (b.value === '') return 1;
          return a.label.localeCompare(b.label, 'fr');
        });
        setContextes(contextesTries);
      }
    } catch (err) {
      console.error('Erreur chargement contextes:', err);
    }
  };

  // Charger tous les mots signalés
  const loadMotsSignales = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('/api/mots/signales');
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Erreur lors du chargement');
      }

      setMots(data.mots || []);
    } catch (err) {
      console.error('Erreur chargement mots signalés:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mots-signales-page">
      <div className="page-header">
        <h1>
          <AlertTriangle size={32} color="#F59E0B" />
          Mots Signalés
        </h1>
        <p className="page-description">
          Gérez les mots signalés comme ayant des erreurs (traduction, orthographe, etc.)
        </p>
      </div>

      <GestionMots
        mots={mots}
        loading={loading}
        error={error}
        onReload={loadMotsSignales}
        showValiderButton={true}
        contextes={contextes}
        emptyMessage="Aucun mot signalé pour le moment"
        emptyHint="Les mots signalés par les utilisateurs apparaîtront ici."
      />
    </div>
  );
}
